import { ArrowUpIcon, ChipClickable } from '@farol-ds/react'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { COMPONENT_CLASS, GA4ClickEvent, SELECTED_OPTION } from '@jusbrasil-web/shared-ga4-events'
import { useOnScroll } from '@jusbrasil-web/shared-hooks'
import classNames from 'classnames'
import { useRef, useState } from 'react'

import { useMetrics } from '../../hooks'
import printStyles from '../../print.module.scss'
import styles from './scroll-to-top-button.module.scss'

export const SCROLL_TOP_TO_SHOW = 1440

type ScrollToTopButtonProps = {
  eventNamespace?: string
  ga4ComponentClass?: string
}

export function ScrollToTopButton({
  eventNamespace = 'Doc',
  ga4ComponentClass = COMPONENT_CLASS.PAGE_NAVIGATION,
}: ScrollToTopButtonProps) {
  const [showButton, setShowButton] = useState(false)
  const lastScrollY = useRef(0)
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLDivElement>()
  const { sendGA4Event } = useGA4Dispatcher()

  const handleScroll = (currentScrollY: number) => {
    setShowButton(currentScrollY < lastScrollY.current && currentScrollY > SCROLL_TOP_TO_SHOW)
    lastScrollY.current = currentScrollY
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })

    sendMetrics(`${eventNamespace}.ScrollToTopButtonClicked`)
    sendGA4Event(
      new GA4ClickEvent({
        componentClass: ga4ComponentClass,
        selectedOption: SELECTED_OPTION.SCROLL_TO_TOP,
        componentName: null,
      })
    )
  }

  useOnScroll({
    callback: handleScroll,
    delay: 0,
  })

  return (
    <ChipClickable
      size="lg"
      onClick={scrollToTop}
      className={classNames(styles.chip, printStyles.unprintable, {
        [styles.chipHidden]: !showButton,
      })}
      data-testid="scroll-to-top-button"
      ref={dispatcherRef}
      leftIcon={<ArrowUpIcon />}
    >
      Voltar ao topo
    </ChipClickable>
  )
}
